import { AdminRole, TournamentAdmin } from '../models';
import { TournamentAdminRepository, TournamentRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class AddTournamentAdminUseCase {
  constructor(
    private tournamentRepository: TournamentRepository,
    private tournamentAdminRepository: TournamentAdminRepository
  ) {}

  async execute(params: {
    tournamentId: string;
    userId: string;
    userEmail: string;
    role: AdminRole;
    requestingUserId: string; // El usuario que hace la petición
  }): Promise<TournamentAdmin> {
    const { tournamentId, userId, userEmail, role, requestingUserId } = params;

    logger.debug('AddTournamentAdmin', 'Adding admin', { tournamentId, userEmail, role });

    // Verificar que el torneo existe
    const tournament = await this.tournamentRepository.getById(tournamentId);
    if (!tournament) {
      throw new Error('Tournament not found');
    }

    // Verificar que el usuario que hace la petición es el dueño
    if (tournament.userId !== requestingUserId) {
      throw new Error('Only the tournament owner can add administrators');
    }

    // Verificar que no se añada al dueño como admin
    if (tournament.userId === userId) {
      throw new Error('Tournament owner is already an administrator');
    }

    // Verificar que el usuario no sea ya admin
    const existingAdmins = await this.tournamentAdminRepository.getByTournamentId(tournamentId);
    const isAlreadyAdmin = existingAdmins.some(admin => admin.userId === userId);

    if (isAlreadyAdmin) {
      throw new Error('User is already an administrator of this tournament');
    }

    // Añadir el admin
    const admin = await this.tournamentAdminRepository.create({
      tournamentId,
      userId,
      role,
    });

    logger.info('AddTournamentAdmin', 'Admin added successfully', { adminId: admin.id });

    return admin;
  }
}
